import { API, getViaWebWorker, get } from './API'
import * as constants from '../../mixins/constants'

export const $_api_getEstimatedFee = (params) =>
  API().get(constants.API.order.estimated_fee, params)

export const loadbankList = async () => {
  const jsonFile = `/banks.min.json`
  return await getViaWebWorker(
    jsonFile,
    {},
    {
      baseURL: location.origin
    }
  )
}

export const getRemoteConfig = () => {
  return getViaWebWorker(
    constants.API.remote_config,
    {},
    {
      token_required: false,
      baseURL: global.$_VUE_APP_REST_API // process.env.VUE_APP_REST_API
    }
  )
}

export const getTranslation = (params) => {
  return getViaWebWorker(constants.API.rest_api.get_translation, params, {
    token_required: false,
    timeout: 100,
    baseURL: global.$_VUE_APP_REST_API // process.env.VUE_APP_REST_API
  })
}

export const getTips = (params) => {
  const uri = constants.API.tips
  return get(uri, params, { token_required: false })
}
